// This file was auto-generated by Fern from our API Definition.
/** The HMAC algorithm used to compute the webhook signature. */
const HmacAlgorithmValues = {
    Sha256: "SHA256",
    Sha1: "SHA1",
    Sha384: "SHA384",
    Sha512: "SHA512",
};
export const HmacAlgorithm = Object.assign(Object.assign({}, HmacAlgorithmValues), { _visit: (value, visitor) => {
        switch (value) {
            case HmacAlgorithm.Sha256:
                return visitor.sha256();
            case HmacAlgorithm.Sha1:
                return visitor.sha1();
            case HmacAlgorithm.Sha384:
                return visitor.sha384();
            case HmacAlgorithm.Sha512:
                return visitor.sha512();
            default:
                return visitor._other();
        }
    } });
